// Whether an overlay that just loaded brings back its last messages.
//
// "Restore on reload" on: always. Off: only when this is a reload in the middle
// of a stream (an OBS refresh, a scene switch that reloads the source, a crash
// and restart), told apart from opening OBS for a new stream by a heartbeat the
// running page writes. A page that was alive moments ago was reloaded; one that
// has been gone longer than RELOAD_WINDOW_MS starts clear, as "Off" promises.

export const RELOAD_WINDOW_MS = 120_000;
/** How often the running page marks itself alive. */
export const HEARTBEAT_MS = 20_000;

export const aliveKey = (overlayId: string) => `sn_overlay_alive_v1:${overlayId}`;

export function shouldRestore(restoreOnReload: boolean, aliveAt: number, now: number): boolean {
  if (restoreOnReload) return true;
  return aliveAt > 0 && now - aliveAt >= 0 && now - aliveAt < RELOAD_WINDOW_MS;
}
